import React, {PropTypes} from "react";
import {connect} from "react-redux";
import VhApplicationsTable from './components/MyVhApplicationsTable';
import axios from 'axios';


class MyVhApplicationsHome extends React.Component {

  constructor() {
    super();
    this.state = ({myVhApplications: null, applicationSelected: null});
    this.getVhPendingAndCurrentApplications = this.getVhPendingAndCurrentApplications.bind(this);
  }

  getVhPendingAndCurrentApplications() {
    //MAKE THE API CALL
    let request = {
      empId: this.props.empID,
      managerStatus: 0,
      ownerStatus: 0,
      vhStatus : 0,
      type: "vh"
    }
    axios.get(process.env.REQ_URL + "/appaccess/getTeamAccessApplications?q="+ JSON.stringify(request), {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let myTeamApplications = response.data.data;
      console.log(myTeamApplications);
      this.setState({myVhApplications: myTeamApplications});
    }).catch((err)=> {
    });
  }

  componentDidMount() {
    //MAKE API CALL TO GET MY TEAM APPLICATIONS
    this.getVhPendingAndCurrentApplications();
    this.props.changeBanner("Vh Team Applications");
  }

  render() {
    console.log(this.props);
    console.log('state data 2');
    console.log(this.state);
    return (
      <div>
        {this.state.myVhApplications !=null? <VhApplicationsTable
          data={this.state.myVhApplications}
          refresh={this.getVhPendingAndCurrentApplications}
        />:null}
      </div>
    );
  }
}

export default (MyVhApplicationsHome);



/** WEBPACK FOOTER **
 ** ./src/feature/appAccess/myVhApplications/myVhApplicationsHome.js
 **/